import { Form, Row } from 'antd';
import React, { useState } from 'react';

import ButtonComponent from 'components/atoms/ButtonComponent';
import DatePickerComponent from 'components/atoms/DatePickerComponent';
import InputComponent from 'components/atoms/InputComponent';
import Paragraph from 'components/atoms/Paragraph';
import SelectComponent from 'components/atoms/SelectComponent';
import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import FormWrapper from 'components/molecules/FormWrapper';

import { useDateLimit } from 'hooks/statniSprava/useDateLimit';
import { useFormBasics } from 'hooks/statniSprava/useFormBasics';

import kategorieRoleSelect from 'data/codebooks/statniSprava/pozadavkyRoleSelect';

import pismenaCislaValidation from 'utils/validations/pismenaCislaValidation';

import AlertComponent from './AlertComponent';
import OdeslaniPozadavkuRows from './odeslaniPozadavkuRows';

interface IF50 {}

const F50: React.FC<IF50> = () => {
    const [form] = Form.useForm();
    const [, dateLoading, commonDisabledDate] = useDateLimit();

    const [nepovinneValErr, setNepovinneValErr] = useState<boolean>(false);
    const [
        errMsg,
        currentStep,
        idSluzby,
        upozorneni,
        loading,
        odeslaniResp,
        setErrMsg,
        prev,
        onFormSubmit,
        showPxKlicLoadingMsg
    ] = useFormBasics();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onFinish = (fieldsValue: any) => {
        if (fieldsValue.idma || fieldsValue.idmb || fieldsValue.pjma || fieldsValue.jmma) {
            const dataToSend = {
                ...fieldsValue,
                dtvp: fieldsValue.dtvp.format('YYYY-MM-DD')
            };
            onFormSubmit(dataToSend);
        } else {
            setNepovinneValErr(true);
        }
    };

    return (
        <LoadingWrapper loading={loading} loadingText={showPxKlicLoadingMsg ? 'LOADING_PXKLIC' : 'NACITANI'}>
            <Title level={4} text="DUVERNE_INFO_TITLE_F50" />{' '}
            {errMsg ? (
                <>
                    <Paragraph text={errMsg} />
                    <Row>
                        <ButtonComponent
                            id="f50ZpetBtn"
                            type="default"
                            buttontext="ZPET"
                            onClick={() => setErrMsg('')}
                        />
                    </Row>
                </>
            ) : (
                <>
                    {currentStep !== 2 ? (
                        <FormWrapper onFinish={onFinish} outForm={form}>
                            <>
                                <LoadingWrapper loading={dateLoading}>
                                    <DatePickerComponent
                                        name="dtvp"
                                        disabled={currentStep > 0}
                                        label="ME_POZADAVKY_DATUM1_POZADOVANE"
                                        disabledDate={current => commonDisabledDate(current)}
                                    />
                                </LoadingWrapper>
                                <InputComponent
                                    label={'ME_POZADAVKY_IDENTIFIKATOR_OSOBYCDCP'}
                                    name="idma"
                                    type="text"
                                    maxLength={100}
                                    notRequired={true}
                                    hide={currentStep === 1 && !form.getFieldValue('idma')}
                                    disabled={currentStep > 0}
                                    onChange={() => setNepovinneValErr(false)}
                                    extramessage={nepovinneValErr ? 'DUVERNE_INFO_NEPOVINNE_ERR' : ''}
                                />
                                <InputComponent
                                    label={'ME_POZADAVKY_ID_SUBJEKTU'}
                                    name="idmb"
                                    rules={pismenaCislaValidation()}
                                    notRequired={true}
                                    type="text"
                                    maxLength={50}
                                    hide={currentStep === 1 && !form.getFieldValue('idmb')}
                                    disabled={currentStep > 0}
                                    onChange={() => setNepovinneValErr(false)}
                                    extramessage={nepovinneValErr ? 'DUVERNE_INFO_NEPOVINNE_ERR' : ''}
                                />
                                <InputComponent
                                    label={'ME_POZADAVKY_PRIJMENO'}
                                    name="pjma"
                                    type="text"
                                    maxLength={250}
                                    notRequired={true}
                                    hide={currentStep === 1 && !form.getFieldValue('pjma')}
                                    disabled={currentStep > 0}
                                    onChange={() => setNepovinneValErr(false)}
                                    extramessage={nepovinneValErr ? 'DUVERNE_INFO_NEPOVINNE_ERR' : ''}
                                />
                                <InputComponent
                                    label={'ME_POZADAVKY_JMENO'}
                                    name="jmma"
                                    type="text"
                                    maxLength={250}
                                    notRequired={true}
                                    hide={currentStep === 1 && !form.getFieldValue('jmma')}
                                    disabled={currentStep > 0}
                                    onChange={() => setNepovinneValErr(false)}
                                    extramessage={nepovinneValErr ? 'DUVERNE_INFO_NEPOVINNE_ERR' : ''}
                                />
                                <SelectComponent
                                    disabled={currentStep > 0}
                                    name="rosb"
                                    labelParagraph="ME_POZADAVKY_ROLE"
                                    labelCol={{
                                        span: 8
                                    }}
                                    data={kategorieRoleSelect}
                                    defaultValue={kategorieRoleSelect[0].value}
                                    isFormItem={true}
                                    notRequired={true}
                                    hide={currentStep === 1 && !form.getFieldValue('rosb')}
                                />
                                {currentStep === 0 && (
                                    <ButtonComponent
                                        id="f50OdeslatBtn"
                                        buttontext="ODESLAT"
                                        onClick={() => form.submit()}
                                    />
                                )}
                                {currentStep !== 0 && upozorneni && (
                                    <AlertComponent
                                        upozorneni={upozorneni}
                                        type={currentStep === 1 ? 'error' : 'info'}
                                    />
                                )}
                                {currentStep === 1 && (
                                    <Row className="button-row">
                                        <ButtonComponent
                                            id="f50ZpetAltBtn"
                                            buttontext="ZPET"
                                            onClick={() => prev()}
                                            type="default"
                                        />
                                        <ButtonComponent
                                            id="f50PotvrditBtn"
                                            buttontext="POTVRDIT"
                                            onClick={() => form.submit()}
                                        />
                                    </Row>
                                )}
                            </>
                        </FormWrapper>
                    ) : (
                        <>
                            <OdeslaniPozadavkuRows idSluzby={idSluzby} datum={odeslaniResp?.datum} />
                            {upozorneni && <AlertComponent upozorneni={upozorneni} type={'info'} />}
                        </>
                    )}{' '}
                </>
            )}
        </LoadingWrapper>
    );
};

export default F50;
